'use strict';

var _ = require('lodash');
/**
 * @class core.intervalsMixin
 */
var intervalsMixin = {
    componentWillMount: function componentWillMount() {
        this.intervals = {};
    },
    componentWillUnmount: function componentWillUnmount() {
        var _this = this;

        _.forEach(this.intervals, function (timerId, timerName) {
            _this.clearIntervalNamed(timerName);
        });
    },
    setIntervalNamed: function setIntervalNamed(timerName, callback, timeout) {
        var _this2 = this;

        if (this.intervals.hasOwnProperty(timerName)) {
            this.clearIntervalNamed(timerName);
        }
        this.intervals[timerName] = setInterval(function () {
            delete _this2.intervals[timerName];
            callback();
        }, timeout);
    },
    setInterval: function setInterval(callback, timeout) {
        this.setIntervalNamed('default', callback, timeout);
    },
    clearIntervalNamed: function clearIntervalNamed(timerName) {
        clearInterval(this.intervals[timerName]);
        delete this.intervals[timerName];
    },
    clearInterval: function clearInterval() {
        this.clearIntervalNamed('default');
    }
};

/**
 * @class core.timeoutsMixin
 */
var timeoutsMixin = {
    componentWillMount: function componentWillMount() {
        this.timeouts = {};
    },
    componentWillUnmount: function componentWillUnmount() {
        var _this3 = this;

        _.forEach(this.timeouts, function (timerId, timerName) {
            _this3.clearTimeoutNamed(timerName);
        });
    },
    setTimeoutNamed: function setTimeoutNamed(timerName, callback, timeout) {
        var _this4 = this;

        if (this.timeouts.hasOwnProperty(timerName)) {
            this.clearTimeoutNamed(timerName);
        }
        this.timeouts[timerName] = setTimeout(function () {
            delete _this4.timeouts[timerName];
            callback();
        }, timeout);
    },
    setTimeout: function setTimeout(callback, timeout) {
        this.setTimeoutNamed('default', callback, timeout);
    },
    clearTimeoutNamed: function clearTimeoutNamed(timerName) {
        if (this.timeouts[timerName]) {
            clearTimeout(this.timeouts[timerName]);
            delete this.timeouts[timerName];
        }
    },
    clearTimeout: function clearTimeout() {
        this.clearTimeoutNamed('default');
    }
};

module.exports = {
    timeoutsMixin: timeoutsMixin,
    intervalsMixin: intervalsMixin
};
//# sourceMappingURL=timersMixins.js.map